import { makeAutoObservable } from "mobx";
import { ICompareValueStore } from "./compare-value-factory";
import FloatCompareValueField from "../../components/policy-editor/policy-eligibility-card/condition-group-card/condition-builder/condition-field/compare-value-type-fields/float-compare-value-field";
import { ensureValidNumber } from "./integer-compare-value-store";

interface ICompareValue {
    value?: number;
}

class FloatCompareValueStore implements ICompareValueStore<number|undefined> {
    private _model: ICompareValue;
    private _changes: Partial<ICompareValue> = {};
    private _uncommittedChanges: Partial<ICompareValue> = {};

    constructor(compareValue?: string) {
        makeAutoObservable(this);
        this._model = { value: ensureValidNumber(compareValue) }; 
    }

    public onOperatorChanged(): void {
    }

    public setChanges(changes?: string) {
        if (changes) {
            this._changes = { value: ensureValidNumber(changes) };
        }
    }

    get Component() {
        return FloatCompareValueField;
    }

    public get value() {
        return this._uncommittedChanges.value ?? this._changes.value ?? this._model.value;
    }

    public setValue(v: number) {
        this._uncommittedChanges.value = v;
    }

    public commitChanges(): void {
        this._changes = {...this._changes, ...this._uncommittedChanges};
        this._clearUnneededChanges();
    }

    public discardUncommittedChanges(): void {
        this._uncommittedChanges = {};
    }

    public hasChanges(): boolean {
        return !!Object.values(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public getUpdatedModel(): string|undefined {
        const updated = { ...this._model, ...this._changes };
        return updated.value?.toString();
    }

    public getUncommittedChanges() {
        return { ...this._model, ...this._changes, ...this._uncommittedChanges }?.value;
    }

    private _clearUnneededChanges() {
        Object.keys(this._changes).forEach(key => {
            const theKey = key as keyof ICompareValue;
            if (this._changes[theKey] === this._model?.[theKey]) {
                delete this._changes[theKey];
            }
        });
    }
}

export default FloatCompareValueStore;
